<template>
  <div id="works-section" class="h-full">
    <div id="works-top">
      <div id="works-title-part">
        <div id="works" class="text-center font-bold text-5xl pt-8 title__black" data-aos="fade-in">Portfolio</div>
        <div id="works-subtitle" class="text-center text-3xl subtitle__black" data-aos="fade-in">
          <b>Select a project</b> to view the details
        </div>
      </div>

      <div class="px-4 xl:px-16 pt-6 sm:pt-16 pb-4 sm:pb-8 mx-auto">
        <VueSlickCarousel v-bind="settings">
          <div v-for="(project, index) in projects" :key="index" class="px-4 py-2">
            <div class="project image-item bg-gray-300 text-center rounded-lg" v-bind:style="projects[index].style" data-aos="fade-up" data-aos-delay="550" v-on:click="selectProject(index)">
              <img class="rounded-lg" :src="globalAssetPath + projects[index].imgSrc" alt="project" />
            </div>
          </div>
        </VueSlickCarousel>
      </div>

      <div class="pt-8 pb-4 px-4 xl:px-32 pb-16">
        <div class="rounded-2xl bg-white border-gray-600 border-2">
          <div class="p-8 grid grid-cols-1 lg:grid-cols-2 gap-4">
            <div>
              <carousel :data="createCarouselData(currentSelected)"></carousel>
            </div>
            
            <div class="p-4">
              <div class="font-bold text-xl">{{ projects[currentSelected].title }}</div>
              <div class="pt-4">{{ projects[currentSelected].description }}<br></div>

              <div class="pt-4 text-md"><strong>TechStack &amp; Services</strong> {{ projects[currentSelected].techstack }}</div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  components: { VueSlickCarousel },
  data() {
    return {
      settings: {
      "dots": true,
      "infinite": false,
      "speed": 500,
      "slidesToShow": 4,
      "slidesToScroll": 4,
      "initialSlide": 0,
      "responsive": [
        {
          "breakpoint": 1024,
          "settings": {
            "slidesToShow": 3,
            "slidesToScroll": 3,
            "infinite": true,
            "dots": true
          }
        },
        {
          "breakpoint": 600,
          "settings": {
            "slidesToShow": 2,
            "slidesToScroll": 2,
            "initialSlide": 2
          }
        },
        {
          "breakpoint": 480,
          "settings": {
            "slidesToShow": 1,
            "slidesToScroll": 1
          }
        }
      ]
    },
      projects: [
        {
          title: "FPS ITB 2020",
          description: 
            "The ITB Choir Festival is a national level choir festival which aims to improve the quality of choirs in Indonesia. The FPS ITB web application was created with the main features of participant registration, uploading files, purchasing tickets, sending emails, and an admin panel.",
          techstack: "PHP Laravel 5, Bootstrap, HTML, CSS, MySQL, AWS RDS, AWS EC2, AWS Route53, Mailgun.",
          style: "",
          imgSrc: '/images/porto/fpsitb.jpg',
          carouselData: [
            '<div class="example-slide">Slide 1 FPS</div>',
            '<div class="example-slide">Slide 2 FPS</div>',
            '<div class="example-slide">Slide 3 FPS</div>',
          ],
          carouselImages: [
            '/images/porto/fpsitb-slide1.jpg',
            '/images/porto/fpsitb-slide2.jpg',
          ],
        },
        {
          title: "Marriage.my.id",
          description: 
            "Marriage.my.id is a web page used to send online wedding invitations. Its main features are sending messages to the bride and groom, invitation data, timer, and background music.",
          techstack: "Python Django, HTML, CSS, MySQL, Google Cloud SQL, Azure Apps Service",
          style: "",
          imgSrc: '/images/porto/marriage.jpg',
          carouselData: [
            '<div class="example-slide">Slide 1 Marriage</div>',
            '<div class="example-slide">Slide 2 Marriage</div>',
            '<div class="example-slide">Slide 3 Marriage</div>',
          ],
          carouselImages: [
            '/images/porto/marriage-slide1.jpg',
            '/images/porto/marriage-slide2.jpg',
          ],
        },
        {
          title: "e-Voting Web Application",
          description: 
            "e-Voting Web Application is made for the implementation of General Elections held by various campus organizations. The application is designed to have high security so as to avoid data leakage. Its main features are voting, sending email, uploading photos, admin panel, and importing data. This application takes advantage of Laravel features such as Mail Queue and DB Transaction. So far, there are 3 Department Student Associations and 1 Student Activity Unit at ITB who have trusted me in making the e-voting application.",
          techstack: "PHP Laravel 8, Vue, Tailwind, HTML, CSS, MySQL, AWS EC2, AWS Route53, Mailgun",
          style: "",
          imgSrc: '/images/porto/evoting.jpg',
          carouselImages: [
            '/images/porto/evoting.jpg',
            '/images/porto/pemilu-hmp.png',
          ],
        },
        {
          title: "Pemira KM ITB 2021",
          description: 
            "The Pemira application is an application for the KM ITB General Election where the election will determine the Chair of the ITB Student Family. The application is designed to have high security so as to avoid data leakage. This application takes advantage of Django Rest Framework features such as Serializer, Permissions, and JWT.",
          techstack: "ReactJS, Python Django (DRF), Bulma, MySQL",
          style: "",
          imgSrc: '/images/porto/pemira.jpg',
          carouselImages: [
            '/images/porto/pemira.jpg',
            '/images/porto/pemira-slide2.jpg',
          ],
        },
        {
          title: "PIKO - People I Know",
          description: 
            "PIKO (People I Know - on The List) is a user contact data storage application. Contact data is stored on the server or local database. Applications are made by slicing figma design into code implementation. Application development also applies clean architecture, clean code, high performance, and high security. Professional Level Android App (Dicoding Approved).",
          techstack: "Android Kotlin, Clean Architecture, Flow & LiveData, Room, Figma, AWS Serverless Stack",
          style: "",
          imgSrc: '/images/porto/piko.jpg',
          carouselImages: [
            '/images/porto/piko.jpg',
            '/images/porto/piko-slide2.jpg',
          ],
        },
        {
          title: "Movinfo",
          description: 
            "Movinfo is an application that displays info about the latest movies and tv shows. The application is built using retrofit, livedata, and room. Expert Level Android App (Dicoding Approved).",
          techstack: "Android Kotlin, LiveData, Room, Retrofit",
          style: "",
          imgSrc: '/images/porto/movinfo.jpg',
          carouselImages: [
            '/images/porto/movinfo.jpg',
            '/images/porto/movinfo.jpg',
          ],
        },
        {
          title: "CurHad - Android Kotlin Chatbot App",
          description: 
            "CurHad is an android application with the main features of which are chatbots and forums. The android application is connected to the Google Cloud Platform server in which there is a Machine Learning model to process user input.",
          techstack: "Android Kotlin, Google Cloud Platform, TensorFlow",
          style: "",
          imgSrc: '/images/porto/curhad.jpg',
          carouselImages: [
            '/images/porto/curhad.jpg',
            '/images/porto/curhad.jpg',
          ],
        },
        {
          title: "CariKerja",
          description: 
            "The CariKerja application is a web-based application that is integrated with the LINE chatbot. Its main features are job application, job search, approve/reject applications, and a list of incoming applications.",
          techstack: "ReactJS, Nodejs, AWS Serverless Stack (Lambda, API Gateway, Cloudwatch), MongoDB Atlas, Dialogflow, LINE Messaging API",
          style: "",
          imgSrc: '/images/porto/carikerja.jpg',
          carouselImages: [
            '/images/porto/carikerja.jpg',
            '/images/porto/carikerja-slide2.jpg',
          ],
        },
      ],
      codeToNum: {
        "fpsitb": 0,
        "bookaholic": 0,
        "marriagemyid": 1,
        "evoting": 2,
        "pemira": 3,
        "carikerja": 7,
        "piko" : 4
      },
      selectedStyle: "box-shadow: 0px 0px 6px 3px rgba(30, 144, 255,1)",
      currentSelected: 0
    }
  },
  methods: {
    selectProject(num) {
      this.projects.forEach(function(part, index) {
        this[index].style = "border-width: 2px; border-color: rgba(113,128,150,0.7))"
      }, this.projects)
      this.projects[num].style = this.selectedStyle
      this.currentSelected = num
    },
    createCarouselData(projectNum) {
      let arr = []
      const { carouselImages } = this.projects[projectNum]

      for (let index = 0; index < carouselImages.length; index++) {
        arr.push('<img src="' + this.globalAssetPath + carouselImages[index] + '" alt="slide" />')
      }
      
      return arr
    }
  },
  beforeMount(){
    const code = this.$route.query.id
    if (code) {
      const num = this.codeToNum[code]
      this.selectProject(num)
    } else {
      this.selectProject(0)
    }

    window.scrollTo(0,0);
  }
}
</script>

<style scoped>
  .project {
    cursor: pointer;
  }

  img {
    pointer-events: none;
  }
</style>

<style>
  .example-slide {
    align-items: center;
    background-color: #666;
    color: #999;
    display: flex;
    font-size: 1.5rem;
    justify-content: center;
    min-height: 20rem;
    text-align: center;
  }
</style>